export default () => ({
  status: "",
});
